// NewPostPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostFormData } from "../../../types/features/Post";
import usePosts from "../../../hooks/features/posts/usePosts";
import PostForm from "../../../components/shared/blog/posts/PostForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";

export default function NewPostPage() {
  const navigate = useNavigate();
  const { createPost } = usePosts();
  const [isLoading, setIsLoading] = useState(false);

  const generateSlug = (title: string) => {
    return title
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  };

  const handleSubmit = async (formData: PostFormData, categoryId: string) => {
    setIsLoading(true);
    const slug = generateSlug(formData.title);
    const success = await createPost({ ...formData, category_id: categoryId, slug });
    setIsLoading(false);
    if (success) {
      navigate(-1);
    }
  };

  return (
    <PageLayout title="Ajouter un nouvel article" className="min-h-screen bg-gray-50 p-6 max-w-7xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Nouvel article</h1>
          <p className="text-gray-500 mt-1">Créez un nouvel article de blog</p>
        </div>
        <PostForm onSubmit={handleSubmit} isLoading={isLoading} />
      </PageContainer>
    </PageLayout>
  );
}
